export const textData = {
  home: {
    titleHome: "Como você está se sentindo hoje?",
    subTitle: "Contamos no momento com apenas 3 categorias de estresse",
    subTitleLittleStressed: "Categoria para pessoas pouco estressadas:",
    descriptionLittleStressed:
      "Nessa categoria temos um botão onde toda vez que você clicar irá ver a foto de um amigão.",
    subTitleStressed: "Categoria para pessoas estressadas:",
    descriptionStressed:
      "Uma categoria onde não é necessario ficar clicando toda hora para ver a foto de um amigão",
    subTitleVeryStressed:
      "Cuidado! Utilize essa categoria apenas se estiver muito estressado.",
    descriptionVeryStressed:
      "Nessa categoria as fotos passam mais rápido, porém você terá que clicar para ler outra piada!",
  },
  routes: {
    home: "Início",
    littleStressed: "Pouco estressado",
    stressed: "Estressado",
    veryStressed: "Muito estressado",
  },
  levelStressed: {
    littleStressed: "",
    stressed: "",
    veryStressed: "",
  },
  littleStressed: {
    title: "Estou um pouco estressado.",
    button: "Alivie seu estresse",
  },
  stressed: {
    title: "Estou estressado!",
  },
  veryStressed: {
    title: "Estou muito estressado!!!",
  },
};
